import { ok, type Result, type ResultError, runSync } from "@maker/result";
import type { BodyInit } from "bun";

const _adapterSymbol = Symbol("parser");

type FetcherMutationDataAdapter = ReturnType<typeof json>;

function isAdapter(data: unknown): data is FetcherMutationDataAdapter {
	return (data as FetcherMutationDataAdapter)._symbol === _adapterSymbol;
}

function createAdapter<T, R extends Result<BodyInit, ResultError>>(
	mime: string,
	transform: (data: T) => R,
) {
	return (data: T) => ({
		data,
		mime,
		transform: () => transform(data),
		_symbol: _adapterSymbol,
	});
}

const json = createAdapter("application/json", (data) =>
	runSync(() => ok(JSON.stringify(data))),
);

export { isAdapter, json, type FetcherMutationDataAdapter };
